package br.com.texeratx.boardgametimeapp.data.model.dashboard

import kotlinx.serialization.Serializable

@Serializable
data class DashboardPlayerDTO(
    val playerId: Long,
    val name: String,
    val nickname: String? = null,
    val imageUrl: String? = null,
    val wins: Int,
    val seconds: Int,
    val participations: Int,
    val winRate: Double,
    val secondRate: Double
)
